import { useCallback, useMemo, useState } from "react";
import type { VendorRfqDetail } from "../types";
import { initialRates, summarise, toPayload, type RateMap } from "../utils/response";

export function useRfqResponseForm(detail: VendorRfqDetail) {
  const [rates, setRates] = useState<RateMap>(() => initialRates(detail));
  const [reviewed, setReviewed] = useState(false);
  const summary = useMemo(() => summarise(detail, rates), [detail, rates]);

  const setRate = useCallback((lineId: number, value: string) => {
    setRates((prev) => ({ ...prev, [lineId]: value }));
  }, []);

  const canSubmit = summary.valid && reviewed;
  const payload = useMemo(() => toPayload(summary), [summary]);

  return { rates, setRate, reviewed, setReviewed, summary, canSubmit, payload };
}
